import { render, staticRenderFns } from "./roomList.vue?vue&type=template&id=68897505&scoped=true"
import script from "./roomList.vue?vue&type=script&lang=js"
export * from "./roomList.vue?vue&type=script&lang=js"
import style0 from "./roomList.vue?vue&type=style&index=0&id=68897505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68897505",
  null
  
)

export default component.exports